import { render, staticRenderFns } from "./header.component.html?vue&type=template&id=72161102&scoped=true&external"
import script from "./header.component.ts?vue&type=script&lang=ts&external"
export * from "./header.component.ts?vue&type=script&lang=ts&external"
import style0 from "./header.component.scss?vue&type=style&index=0&id=72161102&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72161102",
  null
  
)

export default component.exports